import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Lignocellulosic residue: </strong>Key factor in bioethanol
              production from lignocellulosic biomass is its chemical
              composition. The composition of lignocellulosic biomass is
              variable base on their environmental conditions and interactions.
              The biochemical composition of rice and wheat straws is listed in
              Table 1. Major components of these residues (paddy and wheat
              straw) are lignin [C<sub>9</sub>H<sub>10</sub>O<sub>3</sub>(OCH
              <sub>3</sub>)<sub>0.9-1.7</sub>] <sub>n</sub>, cellulose (C
              <sub>6</sub>H<sub>10</sub>O<sub>5</sub>) <sub>x</sub> and
              hemicellulose (C<sub>5</sub>H<sub>8&shy;</sub>O<sub>4</sub>){" "}
              <sub>m. </sub>with the relative share of about 18.81, 36 and 19%
              respectively. Cellulose is mostly composed on glucose subunits
              that are linked linearly by hydrogen bonding. Rigidity to the
              residue is imparted by the number of additional hydrogen bonds and
              also the orientation of linkages.
            </p>
            <p>
              <strong>Bioethanol from Lignocellulosic residue: </strong>
              Simultaneous saccharification and fermentation of feedstock (paddy
              and wheat straw) was carried out by taking 10g of biomass. Biomass
              was subjected to 2% H<sub>2</sub>SO<sub>4, </sub>and the
              pretreated biomass was hydrolysed using{" "}
              <em>V. parahaemolyticus</em> and simultaneously saccharified using
              yeast strain <em>P. kudriavzevii</em>. Paddy straw produced 0.28
              g/g of ethanol (36.7 L/ 100kg) with a conversion efficiency of
              76.62%, and wheat straw produced 0.42 g/g of ethanol
              (53.73L/100kg) with a conversion efficiency of 64.82%. Lower
              ethanol production from rice straw is due to high silica content
              compared with other lignocelluloses. The presence of silica in the
              outer layer of rice straw reduces enzymatic hydrolysis and ethanol
              production yield. In order to improve the ethanol yield from rice
              straw, alkali treatment is carried out using sodium carbonate. It
              was seen that this pretreatment was efficient (&gt;91%) in
              removing silica from the straw. Subjecting rice straw to acid
              pretreatment with ultrasound and subsequent enzyme hydrolysis
              using enzyme extracted from <em>T. reesei </em>and obtained
              ethanol of 11g/L after 7 days of fermentation with{" "}
              <em>S. cerevisiae</em>. Subjecting rice straw to subcritical water
              treatment and enzyme hydrolysis and obtained ethanol of 0.011g/g (
              1.39L/100kg). Lower ethanol yield in this study is due to
              utilization of non-domesticated strain for hydrolysis as well as
              fermentation. However, good ethanol is produced in a shorter
              period than other studies, which can be further improved by
              selecting strains with specific characteristics through
              hybridization or evolutionary engineering techniques.
            </p>
            <p>
              <strong>Effect of pretreatment on straw morphology: </strong>SEM
              images were taken to investigate the lignocellulose morphology,
              structures, and characterization at the nanoscale. SEM images of
              untreated and acid-treated biomass were compared, untreated
              biomass had a smooth surface, whereas the acid-treated biomass
              indicated loosened structures exposing the cellulose structures
              for enzyme hydrolysis.
              <br />
              <br />
            </p>
            <table align="center" width="81%">
              <tbody>
                <tr>
                  <td style={styles.cell} width="50%">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td style={styles.cell}>
                            <p style={{ textAlign: "center" }}>
                              <img src="images/ea4.png" alt="" />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={styles.cell} width="49%">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td style={styles.cell}>
                            <p style={{ textAlign: "center" }}>
                              <img src="images/ea5.png" alt="" />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="50%">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td style={styles.cell}>
                            <p style={{ textAlign: "center" }}>
                              <img src="images/ea6.png" alt="" />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td style={styles.cell} width="49%">
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td style={styles.cell}>
                            <p style={{ textAlign: "center" }}>
                              <img src="images/ea7.png" alt="" />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="2" width="100%">
                    <p style={{textAlign:"center"}}>
                      <strong>Fig 3</strong>. Scanning Electron Microscopy
                      images of paddy straw; <strong>A</strong>: Untreated,{" "}
                      <strong>B: </strong>Acid treated and Wheat straw;{" "}
                      <strong>C</strong>: Untreated, <strong>D:</strong> Acid
                      treated
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                Bioethanol prospects from agricultural residues in India
              </strong>
              : Tables 1 and 2 indicate the availability, seasonality, total and
              surplus biomass production of rice and wheat along with its
              bioethanol potential across states in India. The higher quantity
              of bioethanol potential is directly proportional to the large
              quantity of biomass generated by the state. However, the major
              challenge is the dispersed nature of agriculture residue
              availability, which necessitate setting up biorefineries at
              disaggregated levels.
              <br />
              <br />
            </p>
            <table align="center" width="100%">
              <tbody>
                <tr>
                  <td style={styles.cell} colspan="11" width="100%">
                    <p>
                      <strong>Table 1. </strong>Biochemical composition of
                      selected biomass residue
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="17%">
                    <p>
                      <strong>Biomass residue</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="2" width="19%">
                    <p>
                      <strong>Carbohydrates (per 100g)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="5%">
                    <p>
                      <strong>Fat </strong>
                    </p>
                    <p>
                      <strong>(g)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="7%">
                    <p>
                      <strong>Proteins </strong>
                    </p>
                    <p>
                      <strong>(g)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="6%">
                    <p>
                      <strong>Water</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="8%">
                    <p>
                      <strong>Energy kJ</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="9%">
                    <p>
                      <strong>%Cellulose </strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="12%">
                    <p>
                      <strong>%Hemicellulose</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="7%">
                    <p>
                      <strong>Lignin%</strong>
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="5%">
                    <p>
                      <strong>Ash%</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="6%">
                    <p>
                      <strong>Sugars</strong>
                    </p>
                    <p>
                      <strong>(g)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>
                      <strong>Dietary fibre</strong>
                    </p>
                    <p>
                      <strong>(g)</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="17%">
                    <p>Paddy straw</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>0.05</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>0.4</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>0.28</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>2.6</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>68.44</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>540</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>36</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>19</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>18.81</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>11.88</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="17%">
                    <p>Wheat straw</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>0.41</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>12.2</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>1.54</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>12.61</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>13.1</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>1368</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>36.6</p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>18.9</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>16.2</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>6.6</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <table align="center" width="993">
              <tbody>
                <tr>
                  <td style={styles.cell} colspan="6" width="993">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                    <p>
                      <strong>Table 2. </strong>Availability, Seasonality, Total
                      and surplus biomass production of rice along with its
                      Bioethanol potential state wise
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>States</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>
                      <strong>Availability</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>
                      <strong>Seasons</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>
                      <strong>Total production</strong>
                    </p>
                    <p>
                      <strong>(000 t)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>Surplus production</strong>
                    </p>
                    <p>
                      <strong>(000 t)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>
                      <strong>Bioethanol potential</strong>
                    </p>
                    <p>
                      <strong>(million L)</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Andaman &amp; Nicobar</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>33.46</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>33.46</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0.45</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Andhra Pradesh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>16925.74</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>9360.01</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>367.3</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Arunachal Pradesh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>35.78</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>356.78</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>9.68</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Assam</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>10484.05</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>651.28</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>310.89</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Bihar</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>15035.21</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>1672.26</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>833.82</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Chandigarh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0.21</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>0.21</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Chhattisgarh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>14759.48</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>14759.48</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>400.37</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Dadar &amp;Nagar Haveli</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>48.18</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>47.01</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0.65</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Daman &amp; Diu</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>4.69</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>4.69</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0.06</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Delhi</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="191">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Goa</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>248.33</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>162.4</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>17.51</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Gujarat</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>3156.28</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>2891.88</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>256.85</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Haryana</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>7733.03</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>7733.03</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>500.65</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Himachal Pradesh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>262.43</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>262.43</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>42.71</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Jammu &amp; Kashmir</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>711.71</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>711.71</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>19.31</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Jharkhand</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>7488.94</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>7488.94</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>406.29</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Karnataka</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>8315.67</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>6272.04</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>113.16</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Kerala</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>1090.07</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>332.6</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>25.39</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Lakshadweep</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="191">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="139">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>0</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Madhya Pradesh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>5776.53</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>5776.53</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>156.52</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Maharashtra</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>6200.23</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>6200.23</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>168.18</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Manipur</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>994.58</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>994.58</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>174.48</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Meghalaya</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>201.64</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>122.02</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>16.41</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Mizoram</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>122.03</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>120.26</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>16.36</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Nagaland</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>857.59</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>839.76</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>23.26</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Odisha</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>15502.85</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>1509.52</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>540.24</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Puducherry</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi, early Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>74.77</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>25.18</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>1.01</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Punjab</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>23067.68</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>23067.68</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>4599.73</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Rajasthan</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>586.46</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>586.46</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>0</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Sikkim</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>42.38</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>42.38</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>1.15</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Tamil Nadu</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Earl Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>12598.97</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>12598.97</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>341.76</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Telangana</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>11429.93</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>6488.25</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>248.04</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Tripura</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kahrif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>1786.33</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>1786.33</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>38.76</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Uttar Pradesh</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>27701.21</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>27701.21</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>2037.99</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>Uttarakhand</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>1240.69</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>1137.36</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>50.48</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="168">
                    <p>
                      <strong>West Bengal</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="94">
                    <p>+</p>
                  </td>
                  <td style={styles.cell} width="191">
                    <p>Kharif, Rabi</p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>30648.82</p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>1024.15</p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>297.35</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="3" width="454">
                    <p>
                      <strong>All India</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="139">
                    <p>
                      <strong>225165.95</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="183">
                    <p>
                      <strong>142761.08</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="218">
                    <p>
                      <strong>12016.81</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="6" width="993">
                    <p>
                      <strong>
                        <em>Data source</em>
                      </strong>
                      <em>: National Food Security Mission </em>
                      <a href="https://nfsm.gov.in/dbt/admin/login.aspx">
                        <em>https://nfsm.gov.in/dbt/admin/login.aspx</em>
                      </a>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <table align="center" width="103%">
              <tbody>
                <tr>
                  <td style={styles.cell} colspan="11" width="100%">
                    <p>
                      <strong>Table 4. </strong>Simultaneous saccharification
                      and fermentation of lignocellulosic bio-residue
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>Feedstocks</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>Biomass (g)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="12%">
                    <p>
                      <strong>Acid Pretreatment</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="13%">
                    <p>
                      <strong>Enzyme Hydrolysis</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="14%">
                    <p>
                      <strong>Fermentation</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>
                      <strong>Initial sugar g</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="4%">
                    <p>
                      <strong>Final sugar g</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>
                      <strong>Fermented sugar g</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>
                      <strong>Ethanol g</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>
                      <strong>Theoretical yield</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>
                      <strong>%Conversion efficiency</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>Paddy straw</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="8%">
                    <p>10</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="12%">
                    <p>
                      2% H<sub>2</sub>SO<sub>4</sub>, 121<sup>o</sup>C for 45min
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="13%">
                    <p>
                      <em>V.paraheamolyticus</em>, 55<sup>o</sup>C 100rpm for
                      24h
                    </p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="14%">
                    <p>
                      <em>Pichia kudriavzevii</em>
                    </p>
                    <p>
                      &nbsp;(35<sup>o</sup>C, 100rpm for 72h)
                    </p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>8.12</p>
                  </td>
                  <td style={styles.cell} width="4%">
                    <p>0.75</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>7.37</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>2.88</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>3.76</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>76.62</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="9%">
                    <p>Wheat straw</p>
                  </td>
                  <td style={styles.cell} width="5%">
                    <p>13.8</p>
                  </td>
                  <td style={styles.cell} width="4%">
                    <p>0.98</p>
                  </td>
                  <td style={styles.cell} width="7%">
                    <p>12.82</p>
                  </td>
                  <td style={styles.cell} width="6%">
                    <p>4.24</p>
                  </td>
                  <td style={styles.cell} width="8%">
                    <p>6.54</p>
                  </td>
                  <td style={styles.cell} width="9%">
                    <p>64.85</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
